import { PageBody } from '@uhg-abyss/web/ui/PageBody';
import { styled } from '@uhg-abyss/web/tools/styled';
import { Flex } from '@uhg-abyss/web/ui/Flex';
import { mobileOnly } from '@/style/mediaQueries';

export const StyledPageBody = styled(PageBody, {
  '.abyss-page-body-container': {
    maxWidth: '100%',
  },
});

export const ErrorPageContent = styled(Flex, {
  alignContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  [`@media ${mobileOnly}`]: {
    alignContent: 'flex-start',
    flexDirection: 'row-reverse',
    marginTop: 'var(--abyss-space-md)',
  },
  '@screen < $xs': {
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    flexDirection: 'row',
  },
});

export const ErrorPageBodyContainer = styled('div', {
  alignContent: 'center',
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  [`@media ${mobileOnly}`]: {
    alignItems: 'flex-start',
    alignContent: 'flex-start',
    flex: '5 4 40%',
  },
});

export const ErrorPageErrorContainer = styled('div', {
  '.abyss-text-root': {
    display: 'block',
    marginTop: '34px',
    marginBottom: '4px',
    [`@media ${mobileOnly}`]: {
      marginTop: 'unset',
      marginBottom: 'var(--abyss-space-lg)',
    },
  },
});

export const ErrorPageMainHeaderContainer = styled('div', {
  marginBottom: '4px',
  '@screen < $sm': {
    marginBottom: '16px',
  },
});

export const ErrorPageSubHeaderContainer = styled('div', {
  marginBottom: '12px',
  '@screen < $sm': {
    marginBottom: '20px',
    maxWidth: '181px',
  },
});

export const ErrorPageSubTextContainer = styled('div', {
  alignItems: 'center',
  color: '#424242',
  display: 'flex',
  flexDirection: 'column',
  marginBottom: '80px',
  maxWidth: '60%',
  textAlign: 'center',
  [`@media ${mobileOnly}`]: {
    alignItems: 'flex-start',
    gap: '-10px',
    marginBottom: '40px',
    maxWidth: '100%',
    textAlign: 'left',
  },
});
